"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 03 2018
 */

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * {@code ResultList} converter. Typically serves for serialization on backend and
 * deserialization on frontend side.
 *
 * @author Radek Beran
 */


var ResultListConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ResultListConverter, _DataObjectConverter_);

  function ResultListConverter() {
    _classCallCheck(this, ResultListConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResultListConverter).apply(this, arguments));
  }

  return ResultListConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ResultListConverter = ResultListConverter;